import { Box } from "@mui/material";

import { Navigate, Route, Routes } from "react-router-dom";

import AppVersion from "components/AppVersion/AppVersion";
import { IZone } from "interfaces/zone.interface";

import { ZoneLandingPage } from "../zones/ZoneLandingPage";
import { ZoneCreatePage } from "../zones/zoneSettings/ZoneCreatePage";

type AdminMainContainerProps = {
  zones: IZone[];
};

export const AdminMainContainer = ({ zones }: AdminMainContainerProps) => {
  return (
    <Box
      sx={() => ({
        display: "flex",
        flex: 1,
        flexDirection: "column",
        justifyContent: "space-between",
        overflow: "auto",
      })}
    >
      <Box
        sx={{
          flex: "1",
          display: "flex",
          flexDirection: "column",
          height: "100%",
          width: "100%",
        }}
      >
        <Routes>
          <Route index element={<Navigate to={"zones"} />} />
          <Route
            path={"zones/:zoneId?/*"}
            element={<ZoneLandingPage zones={zones} />}
          />
          <Route
            path={"create-zone"}
            element={<ZoneCreatePage zones={zones} />}
          />
        </Routes>
        <AppVersion />
      </Box>
    </Box>
  );
};
